import React, {Fragment, useEffect, useState} from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from 'react-router-dom'
import MainTitleBoxes from "./components/MainTitleBoxes/MainTitleBoxes.js";
import HeaderComp from "./components/HeaderComp/HeaderComp";
import InfoBox from "./components/InfoBox/InfoBox";
import TitleSection from "./components/TitleSection/TitleSection";
import Paper from '@material-ui/core/Paper';
import Typography           from '@material-ui/core/Typography';
import ErrorIcon            from '@material-ui/icons/Error';
import makeStyles from "@material-ui/core/styles/makeStyles";
import {createStyles} from "@material-ui/core";
import Form from "./components/Form/Form";
import {
    infoArrive,
    CallDataWinterSoldier,
    capitalize,
    removeAccents,
    GetSortOrder
} from './helper/HelperFunctions'
import BreadCrumb from "./components/BreadCrumb/BreadCrumb";
import NoCountryAvaible from "./components/NoCountryAvaible/NoCountryAvaible";
import Loading from "./components/Loading/Loading";
import {
    COUNTRY_DETECTOR, OPEN_COUNTRIES
} from './constants'

const useStyles = makeStyles(() => createStyles({
    responseContainer: {
        padding: 32,
        display: 'flex',
        marginLeft: 'auto',
        marginRight: 'auto',
        flexFlow: 'column nowrap',
        alignItems: 'center',
        backgroundColor: 'transparent',
        margin: '16px 0',
        width: 320,
        maxWidth: '600px',
        overflow: 'scroll !important',
},
    iconFailure: {
        color: 'red',
        fontSize: 120,
        marginTop: -10
    },
    titleTheme: {
        color: 'black',
        fontWeight: 'normal',
        margin: '10px auto'
    },
    text: {
        color: 'dimgrey',
        fontSize: 14,
        textAlign: 'center',
        marginBottom: 24
    },
    maxContainer: {
        width: '100%',
        display: 'block',
        margin: 0,
        padding: 0
    }
}));

function WinterSoldier() {
    const {
        responseContainer,
        iconFailure,
        titleTheme,
        text,
        maxContainer
    } = useStyles();

    const [infoData, setInfoData] = useState([])
    const [titlesData, setTitlesData] = useState([])
    const [subtitlesData, setSubtitlesData] = useState([])
    const [infoBool, setInfoBool] = useState(false)
    const [title, setTitle] = useState({})
    const [country, setCountry] = useState("")
    const [invalidPage, setInvalidPage] = useState(false)
    const [error, setError] = useState(false)
    const [errorCode, setErrorCode] = useState(0)
    const [errorMessage, setErrorMessage] = useState("")
    const [loading, setLoading] = useState(true)
    const [isMobile, setIsMobile] = useState(null)
    const [alreadyAskFetch, setAlreadyAskFetch] = useState(true)
    const [theCountryIsHere, setTheCountryIsHere] = useState(true)
    const [flag, setFlag] = useState(false)
    const [errorCatchCountry, setErrorCatchCountry] = useState(false)
    const [allCountries, setAllCountries] = useState([])

    const callCFCountry = async () => {
        fetch(COUNTRY_DETECTOR)
            .then(response => response.json())
            .then(function(json) {
                const country = Object.values(OPEN_COUNTRIES).find(country => country.code === json?.geo_data?.country?.iso_code);
                if (!!country) {
                    setCountry(() => country.label);
                } else {
                    setCountry(() => 'Mexico');
                }
                setErrorCatchCountry(false);
            })
            .then(()=> setError(false))
            .then(()=> setFlag(true))
            .catch(err => {
                setErrorCatchCountry(true)
                console.log('Request Failed', err)
            });
    }

    useEffect(()=>{
        errorCatchCountry && callCFCountry()
    }, [errorCatchCountry])
    
    useEffect(()=>{
        CallDataWinterSoldier(setTitlesData, setSubtitlesData, setInfoData, alreadyAskFetch, setAlreadyAskFetch)
        callCFCountry()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(()=>{
        errorCatchCountry && callCFCountry()
    }, [errorCatchCountry])

    useEffect(()=>{
        isMobile
            ? document.body.style.backgroundColor = "white"
            : document.body.style.backgroundColor = "#EEEEEE"

        setIsMobile(/iPhone|iPad|iPod|Android|BlackBerry|Symbian|Ubuntu/i.test(navigator.userAgent))

        setErrorCode(201)
        setErrorMessage('no error')

        if(infoArrive(infoData)){
            infoData.sort(GetSortOrder("score"))
            titlesData.sort(GetSortOrder("score"))
            subtitlesData.sort(GetSortOrder("score"))
        }

        if(infoData.length>0){
            infoData.sort(GetSortOrder("score"))
        }
    }, [infoData, titlesData, subtitlesData, isMobile, country])

    useEffect(()=>{
        if(theCountryIsHere){
            theCountryIsHere && setError(false)
        }

        if(!infoArrive(infoData)){
            setError(true)
        }
    }, [theCountryIsHere, infoData])

    useEffect(()=>{
        let response = []
        subtitlesData.forEach(function(row){
            let resSplit = row.country.split(/(?:,| )+/)
            resSplit.forEach(resRow => response.push(capitalize(removeAccents(resRow)).trim()))
        })

        response = response.filter(function(item, pos, self) {
            return self.indexOf(item) === pos
        })

        response.forEach(singleRes => (setAllCountries(setAllCountries => [...setAllCountries, singleRes])))
    }, [subtitlesData])

    useEffect(()=>{
        if(infoArrive(titlesData) && !allCountries.includes(country.trim()) && flag){
            setTheCountryIsHere(false)
            setLoading(false)
        }

        if(infoArrive(titlesData) && allCountries.includes(country.trim()) && flag){
            sessionStorage.setItem('country', country);
            setTheCountryIsHere(true)
            setLoading(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [country, flag, allCountries, titlesData])

    return (
        <div className={maxContainer}>
            <Router>
                <HeaderComp
                    setInfoBool={setInfoBool}
                    isMobile={isMobile}
                />
                {
                    loading && (
                        <Loading/>
                    )
                }

                { !loading &&
                    <Fragment>
                        {
                            !isMobile && theCountryIsHere && (
                                <BreadCrumb
                                    setTitle={setTitle}
                                    theCountryIsHere={theCountryIsHere}
                                />
                            )
                        }
                        <TitleSection
                            titlesData={titlesData}
                            subtitlesData={subtitlesData}
                            infoData={infoData}
                            setTitlesData={setTitlesData}
                            setSubtitlesData={setSubtitlesData}
                            setInfoData={setInfoData}
                            title={title}
                            setTitle={setTitle}
                            country={country}
                            invalidPage={invalidPage}
                            setInvalidPage={setInvalidPage}
                            isMobile={isMobile}
                            theCountryIsHere={theCountryIsHere}
                            setTheCountryIsHere={setTheCountryIsHere}
                            flag={flag}
                        />
                        <Switch>
                            <Route exact path='/contact-us/:idFormType?'>
                                <Form
                                    isMobile={isMobile}
                                />
                            </Route>

                            <Route exact path='/country-error'>
                                {
                                    !theCountryIsHere && (
                                        <NoCountryAvaible/>
                                    )
                                }
                                {
                                    theCountryIsHere && (
                                        <Loading/>
                                    )
                                }
                            </Route>

                            <Route path="/">
                                {
                                    loading && (
                                        <Loading/>
                                    )
                                }
                                {
                                    error && !loading && !invalidPage && !theCountryIsHere && (
                                        <Paper data-testid='error-screen' elevation={0} className={responseContainer}
                                               style={{width: '80%'}}>
                                            <ErrorIcon className={iconFailure}/>
                                            <Typography variant={'h6'}
                                                        className={titleTheme}>{`ERROR: ${errorCode}`}</Typography>
                                            <Typography variant={'body2'} className={text}>
                                                Algo salio mal, por favor vuelve a intentarlo mas tarde.
                                            </Typography>
                                            <Typography variant={'body2'} className={text}>`${errorMessage}`</Typography>
                                        </Paper>
                                    )
                                }
                                {
                                    infoBool && !invalidPage && (
                                        <InfoBox
                                            infoData={infoData}
                                            country={country}
                                            isMobile={isMobile}
                                        />
                                    )
                                }
                                {
                                    titlesData && !loading && !error && !infoBool && !invalidPage && (
                                        <MainTitleBoxes
                                            titlesData={titlesData}
                                            subtitlesData={subtitlesData}
                                            setInfoBool={setInfoBool}
                                            country={country}
                                            isMobile={isMobile}
                                        />
                                    )
                                }
                                {
                                    invalidPage && (
                                        <Paper data-testid='error-screen' elevation={0} className={responseContainer}
                                               style={{width: '80%'}}>
                                            <ErrorIcon className={iconFailure}/>
                                            <Typography variant={'h6'}
                                                        className={titleTheme}>{`ERROR: Path error`}</Typography>
                                            <Typography variant={'body2'} className={text}>La página que intentas visitar no
                                                se encuentra disponible</Typography>
                                            <Typography variant={'body2'} className={text}>Intente ingresando una URL
                                                diferente</Typography>
                                        </Paper>
                                    )
                                }
                            </Route>
                        </Switch>
                    </Fragment>
                }
            </Router>
        </div>
    );

}

export default WinterSoldier;
